module.exports = __webpack_public_path__ + "static/media/28.0891f293.jpg";